import { render, staticRenderFns } from "./_MyReservationCard.vue?vue&type=template&id=667da00e&scoped=true&"
import script from "./_MyReservationCard.vue?vue&type=script&lang=js&"
export * from "./_MyReservationCard.vue?vue&type=script&lang=js&"
import style0 from "./_MyReservationCard.vue?vue&type=style&index=0&id=667da00e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667da00e",
  null
  
)

export default component.exports